import * as React from 'react';
import styled from 'styled-components';

import { getSlateEditorValue } from '@doltech/utils/lib/editor';

import { RendererWithPlugins } from '../../../slatePlugins/components/core/readonly/RendererWithPlugins';
import { ParagraphPlugin } from '../../../slatePlugins/components/core/readonly/ParagraphPlugin';
import { useBlogEditorExercisePlugins } from '../../../editor-save-data/hooks/useBlogEditorExercisePlugins';
import { useBlogEditorReadOnlyPlugin } from '../../BlogEditor/hooks/useBlogEditorReadOnlyPlugin';
import { MediaType } from '../../DolEditor/elements/media-constant';
import { PluginPresetEnum } from '../../BlogEditor/BlogEditor.types';
import { ImageToggleReadOnlyPlugin } from '../../BlogEditor/plugins-common/ImageToggle/ImageToggleReadOnlyPlugin';
import { commonStyles, spacingStyles } from './styles';
import { tableStyles } from './tableStyles';

const Container = styled.div`
  ${commonStyles}
  ${spacingStyles}
  ${tableStyles}
`;

interface BlogPageElementBodyProps {
  bodyValue?: any;
  mediaInfos?: any[];
  exerciseProgressData?: any[];
  onCheckExerciseAnswer?: (payload) => void;
}

export const BlogPageElementBody = (props: BlogPageElementBodyProps) => {
  const { bodyValue, mediaInfos, exerciseProgressData, onCheckExerciseAnswer } = props;

  const { plugins, preprocessReadOnlyInitialValues } =
    useBlogEditorReadOnlyPlugin({
      presets: [
        PluginPresetEnum.HEADING,
        PluginPresetEnum.TEXT_FORMAT,
        PluginPresetEnum.BLOCK_FORMAT,
        PluginPresetEnum.HTML_OBJECT,
        PluginPresetEnum.MEDIA_OBJECT,
        PluginPresetEnum.DIVIDER,
        PluginPresetEnum.SPECIAL_OBJECT,
        PluginPresetEnum.CORE_PARAGRAPH_AT_END,
      ]
    });

  const initialValue = getSlateEditorValue(bodyValue)
    ?.map((eachElement) => {
      const foundMediaInfo = mediaInfos?.find((eachMediaInfo) => eachMediaInfo?.id === eachElement?.id);
      if (foundMediaInfo) {
        if (eachElement.type === MediaType.VIDEO) {
          return {
            ...eachElement,
            ...foundMediaInfo,
          };
        }

        return {
          ...eachElement,
          fileInfo: foundMediaInfo,
        };
      }
      return eachElement;
    });

  const { exercisePlugins } = useBlogEditorExercisePlugins({
    initialValue: preprocessReadOnlyInitialValues({ initialValue }),
    progressData: exerciseProgressData,
    onCheckAnswer: onCheckExerciseAnswer,
  });

  return (
    <Container className="blog-editor-element-body">
      <RendererWithPlugins
        plugins={[
          ...plugins,
          ...exercisePlugins,
          ImageToggleReadOnlyPlugin({ isReadOnly: true }),
          ParagraphPlugin,
        ]}
        value={preprocessReadOnlyInitialValues({ initialValue })}
      />
    </Container>
  );
};
